export default __webpack_public_path__ + "static/media/党1.e1a8fb41.png";